import { sumOf } from '../../../../shared/utils/arrayUtils';
import { Operation } from '../../../types/sharedTypeImpl';
import { LIVE_GRAPH_MED } from '../../../utils/liveGraphColors';
import { BarGraphData, BarGroup } from '../barGraphData';
import { PeriodOption } from '../report-settings/reportSettings';


export function prepareConfirmedScraps(operations: Operation[], periods: PeriodOption[]): BarGraphData {
    const dataInitial = periods.map(period => {
        const operationsWeek = operations
            .filter(it => it.effectiveTime != null && it.effectiveTime >= period.start && it.effectiveTime < period.end);

        const potentialScraps = sumOf(operationsWeek, it => it.potentialScraps ?? 0);
        const additionalScraps = sumOf(operationsWeek, it => it.scrapCloseForm!.addedConfirmedScrap ?? 0);
        const confirmedRatio = potentialScraps > 0 ? additionalScraps / potentialScraps : 0;
        return {
            value: confirmedRatio,
            color: LIVE_GRAPH_MED,
            periodLabel: period.periodLabel,
            valueLabel: confirmedRatio.toFixed(2),
        };
    });

    const barGroups: BarGroup[] = dataInitial.map(data => ({
        periodLabel: data.periodLabel,
        bars: [{
            sections: [{
                value: data.value,
                color: data.color,
                labels: [{ position: 'below-top', text: data.valueLabel }],
            }],
        }],
    }));

    return {
        barGroups,
        maxValue: 1.0,
    };
}
